export function deriveStatus(oh) {
  if (oh?.status === "Cancelled") return "Cancelled";
  if (oh?.feedback) return "Completed";
  return "Scheduled";
}

export function sortOpenHouses(rows) {
  return [...rows].sort((a, b) => {
    const aIsScheduled = deriveStatus(a) === "Scheduled";
    const bIsScheduled = deriveStatus(b) === "Scheduled";
    if (aIsScheduled !== bIsScheduled) return aIsScheduled ? -1 : 1;
    if (aIsScheduled) return (a.date || "").localeCompare(b.date || "");
    return (b.date || "").localeCompare(a.date || "");
  });
}

const ELIGIBLE_STAGES = new Set(["Coming Soon", "Active"]);

export function filterEligibleListings(deals) {
  return deals.filter(
    (d) => d?.dealtype === "Seller" && ELIGIBLE_STAGES.has(d?.dealStage)
  );
}

export function formatTimeRange(start, end) {
  if (!start || !end) return "—";
  return `${formatTime(start)} – ${formatTime(end)}`;
}

function formatTime(t) {
  const [hStr, mStr] = String(t).split(":");
  const h = Number(hStr);
  if (isNaN(h)) return t;
  const period = h >= 12 ? "pm" : "am";
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}:${(mStr || "00").padStart(2, "0")}${period}`;
}

export function generateFeedbackToken() {
  const bytes = new Uint8Array(16); // 16 bytes = 128 bits of entropy
  window.crypto.getRandomValues(bytes);
  // Base64url-encode (URL-safe, no padding)
  let b64 = btoa(String.fromCharCode(...bytes));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// Decide whether to send the listing agent a copy of an open-house email and
// to whom. Pure + synchronous so it is easy to unit-test. Returns the recipient
// { email, name } to send to, or null to skip (no email, or the agent is already
// being emailed in this flow — deduped against excludeEmails).
export function chooseListingAgentRecipient({
  agentEmail,
  agentName,
  excludeEmails = [],
}) {
  const email = String(agentEmail || "").trim();
  if (!email) return null;
  const lower = email.toLowerCase();
  const excluded = excludeEmails
    .map((e) => String(e || "").trim().toLowerCase())
    .filter(Boolean);
  if (excluded.includes(lower)) return null;
  return { email, name: String(agentName || "").trim() };
}
